/**
 * These are all runtime dependencies. Any breaking changes
 * will need a migration path first!
 */
const prefix = 'urn';
const namespace = 'sfextslot';
const owner = 'request-list-pilet';
const blockNamespace = `${prefix}:block:request-list`;
const deprecated_blockNamespace = `${prefix}:sfblock:request-list`;
const resourceType = 'requestlist';
export const requestListExtensionSlots = {
    itemDetailsTabs: `${prefix}:${namespace}:${owner}:request-list:item-details:tabs`,
    itemRowMetadata: `${prefix}:${namespace}:${owner}:request-list:item-row:metadata`,
    taskBadge: `${prefix}:${namespace}:${owner}:request-list:task:badge`,
    /** @deprecated */
    deprecated_viewListBlock: `${deprecated_blockNamespace}:view:list`,
    viewListBlock: `${blockNamespace}:view:list`,
    attachmentsTabLabel: `${prefix}:${namespace}:${owner}:drawer:attachments:tab`,
    projectTab: `${prefix}:${namespace}:${owner}:project:tab:request-lists`,
    projectTile: `${prefix}:${namespace}:${owner}:project:tile:request-lists`,
    recentlyDeletedTab: `${prefix}:${namespace}:${owner}:project:recently-deleted:request-lists-tab`,
    //These are consumed in the client view drawer. The extension slots used to exist in client-dashboard and will need to be renamed
    commentsTab: `${prefix}:${namespace}:client-dashboard-pilet:comments-tab`,
    drawerCommentsContent: `${prefix}:${namespace}:client-dashboard-pilet:drawer:comments:content`,
    shareButton: `${prefix}:${namespace}:request-list:share-button`,
    specEditor: `${prefix}:${namespace}:${resourceType}:spec-editor`,
    taskProgressBar: `${prefix}:${namespace}:task-aggregator:progress-bar:requestlist`,
    contextActionsMenu: `${prefix}:${namespace}:task-aggregator:requestlist_card_actions`,
};
export const piletOverlays = {
    clientViewRequestListDrawer: 'urn:sfdrawer:task-aggregator:client:requestlist_item',
    createRequestListDrawer: 'urn:sfdrawer:request-list-pilet:create-request-list',
    viewRequestListDrawer: 'urn:sfdrawer:task-aggregator:requestlist',
};
//# sourceMappingURL=extensionTypes.js.map